import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import GroupIcon from '@material-ui/icons/Group';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import ListAlt from '@material-ui/icons/ListAlt';
import MailIcon from '@material-ui/icons/Mail';
import PersonIcon from '@material-ui/icons/Person';
import ParishIcon from '@material-ui/icons/StoreMallDirectory';
import EducationIcon from '@material-ui/icons/LocalLibrary';
import AdminSettingsIcon from '@material-ui/icons/Settings';
import DashboardIcon from '@material-ui/icons/Home';
import React from 'react';
import { ADMIN_LINKS, NAV_LINKS } from './constants';

const { DASHBOARD, DEVOTEES, CHECKLISTS, PARTICIPATION, DEVOTIONAL_GROUPS } = NAV_LINKS;

const { PARISHES, EDUCATION, ADMIN } = ADMIN_LINKS;

const getNavIcon = (link) => {
  switch (link) {
    case DEVOTEES:
      return <PersonIcon />;
    case CHECKLISTS:
      return <AssignmentTurnedInIcon />;
    case PARTICIPATION:
      return <ListAlt />;
    case DEVOTIONAL_GROUPS:
      return <GroupIcon />;
    case PARISHES:
      return <ParishIcon />;
    case EDUCATION:
      return <EducationIcon />;
    case DASHBOARD:
      return <DashboardIcon />;
    case ADMIN:
      return <AdminSettingsIcon />;
    default:
      return <PersonIcon />;
  }
};

export {
  getNavIcon,
  AssignmentTurnedInIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  GroupIcon,
  InboxIcon,
  ListAlt,
  MailIcon,
  PersonIcon,
  AdminSettingsIcon,
};
